'use client';

import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { SWRConfig } from 'swr';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@/lib/theme';
import { ConfirmProvider } from 'material-ui-confirm';
import MuiXLicense from './MuiXLicense';
import { AuthenticationProvider } from './AuthenticationProvider';
import { HeartBeat } from './HeartBeat';
import { IntlProvider } from './IntlProvider';
import { ShellContextProvider } from './ShellContext';
import { SnackbarProvider } from './SnackbarProvider';
import { DatadogProvider } from '@/components/datadogprovider/DatadogProvider';
import { LaunchDarklyProvider } from './LaunchDarklyProvider';

export interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <LaunchDarklyProvider>
      <DatadogProvider>
        <MuiXLicense />
        <CssBaseline />
        <SWRConfig
          value={{
            revalidateIfStale: false,
            revalidateOnFocus: false,
          }}
        >
          <HeartBeat>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <AuthenticationProvider>
                  <IntlProvider>
                    <SnackbarProvider>
                      <ConfirmProvider>
                        <ShellContextProvider>{children}</ShellContextProvider>
                      </ConfirmProvider>
                    </SnackbarProvider>
                  </IntlProvider>
                </AuthenticationProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </HeartBeat>
        </SWRConfig>
      </DatadogProvider>
    </LaunchDarklyProvider>
  );
};
